import { render, staticRenderFns } from "./StatusTeeth.vue?vue&type=template&id=610dc178&scoped=true&"
import script from "./StatusTeeth.vue?vue&type=script&lang=js&"
export * from "./StatusTeeth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610dc178",
  null
  
)

export default component.exports